import NamedStorage from "./NamedStorage";

export default class PlayerInventoryStorage {
  private mStorage: NamedStorage;

  constructor() {
    this.mStorage = new NamedStorage("PlayerInventory");
  }

  public GetCurrentBow(): string {
    return this.mStorage.Get("CurrentBow");
  }

  public SetCurrentBow(currentBow: string) {
    return this.mStorage.Store("CurrentBow", currentBow);
  }

  public GetOwnedBows(): string[] {
    return this.mStorage.GetArray("OwnedBows");
  }

  public AddOwnedBows(bow: string) {
    return this.mStorage.StoreInArray("OwnedBows", bow);
  }
  // OwnedBows - array of string
}
